const QUIZ_TOTAL_STEPS = 6;
const QUIZ_RING_CIRCUMFERENCE = 1068;
const QUIZ_EMAIL_SUBTITLE_SUCCESS = 'Your £5 discount code will be sent directly to your email.';
// 测试环境；上线后改为 https://global.shokz.com
const XS_FLASHIP_API_BASE = 'https://global.shokz.com';
const XS_FLASHIP_API_PATH = '/api/v1/quiz/xs-preheat';
const XS_FLASHIP_API_KEY = 'LKfmwsVjCsd8jkP8UFo68PH8P8gZemsRHsfKd';

class FlashipQuiz {
  constructor(root) {
    this.root = root;
    this.state = {
      step: 1,
      answers: {
        color: '',
        colorOther: '',
        price: '',
        usage: '',
        gender: '',
        age: ''
      }
    };

    this.klaviyoFormId = (root.dataset.klaviyoFormId || 'XhUc9X').trim();
    this.progressFill = root.querySelector('.quiz-progress__fill');
    this.prevBtn = root.querySelector('[data-prev]');
    this.nextBtn = root.querySelector('[data-next]');
    this.otherInput = root.querySelector('[data-other-input]');
    this.confetti = root.querySelector('.quiz-progress__confetti');

    this.bindOptionEvents();
    this.bindNavigation();
    this.bindSubscribeGa4();
    this.updateUI();
  }

  bindOptionEvents() {
    this.root.querySelectorAll('[data-option]').forEach((button) => {
      button.addEventListener('click', () => this.selectOption(button));
    });

    const colorsGroup = this.root.querySelector('.quiz-options--colors');
    if (colorsGroup) {
      colorsGroup.querySelectorAll('.quiz-option').forEach((button) => {
        button.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 769px)').matches) return;
          colorsGroup.classList.add('is-hovering');
          colorsGroup.querySelectorAll('.quiz-option').forEach((el) => {
            el.classList.remove('is-expanded');
          });
          button.classList.add('is-expanded');
        });
      });

      colorsGroup.addEventListener('mouseleave', () => {
        colorsGroup.classList.remove('is-hovering');
        colorsGroup.querySelectorAll('.quiz-option').forEach((el) => {
          el.classList.remove('is-expanded');
        });
      });
    }

    if (this.otherInput) {
      this.otherInput.addEventListener('focus', () => {
        const otherBtn = this.root.querySelector('[data-value="other"]');
        if (otherBtn && !otherBtn.classList.contains('is-selected')) {
          this.selectOption(otherBtn);
        }
      });
      this.otherInput.addEventListener('input', () => {
        this.state.answers.colorOther = this.otherInput.value.trim();
        this.updateUI();
      });
      this.otherInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (this.canProceed()) this.goNext();
        }
      });
    }
  }

  selectOption(button) {
    const step = Number(button.dataset.step);
    const value = button.dataset.value || '';
    const group = button.closest('[data-option-group]');

    if (group) {
      group.querySelectorAll('[data-option]').forEach((item) => item.classList.remove('is-selected'));
    }

    button.classList.add('is-selected');

    if (step === 1) {
      this.state.answers.color = value;
      if (value !== 'other') {
        this.state.answers.colorOther = '';
        if (this.otherInput) this.otherInput.value = '';
      } else if (this.otherInput) {
        this.otherInput.focus();
      }
    } else if (step === 2) {
      this.state.answers.price = value;
    } else if (step === 3) {
      this.state.answers.usage = value;
    } else if (step === 4) {
      this.state.answers.gender = value;
    } else if (step === 5) {
      this.state.answers.age = value;
    }

    this.updateUI();
  }

  bindNavigation() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goPrev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goNext());
  }

  destroy() {
    // Reserved for section unload cleanup.
  }

  getKlaviyoEmail() {
    const quizEmail = this.root.querySelector('.quiz-email');
    if (!quizEmail) return '';

    const emailInput =
      quizEmail.querySelector('input[type="email"]') ||
      quizEmail.querySelector('input[name="email"]') ||
      quizEmail.querySelector('input');

    return (emailInput?.value || '').trim();
  }

  getApiEndpoint() {
    const customEndpoint = (this.root.dataset.apiEndpoint || '').trim();
    if (customEndpoint) return customEndpoint;

    return `${XS_FLASHIP_API_BASE.replace(/\/$/, '')}${XS_FLASHIP_API_PATH}`;
  }

  pushSubscribeGa4(email, status) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'subscribe',
      event_parameters: {
        module: 'xs_preheat_subscription',
        status,
        email,
        content_name: this.buildSubscribeContentName()
      }
    });
  }

  bindSubscribeGa4() {
    const quizEmail = this.root.querySelector('.quiz-email');
    if (!quizEmail) return;

    const bindSubmitButton = () => {
      const submitBtn =
        quizEmail.querySelector('.go4147362152.go4147362152.go4147362152') ||
        quizEmail.querySelector('button[type="submit"]') ||
        quizEmail.querySelector('button');

      if (!submitBtn || submitBtn.dataset.ga4SubscribeBound) return false;

      submitBtn.dataset.ga4SubscribeBound = 'true';
      submitBtn.addEventListener('click', () => {
        const email = this.getKlaviyoEmail();
        if (!email || submitBtn.dataset.apiSubmitting === 'true') return;

        submitBtn.dataset.apiSubmitting = 'true';
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        this.submitQuizData(email)
          .then((status) => {
            this.pushSubscribeGa4(email, status);
            if (status === 'success') {
              this.updateEmailSubtitleOnSuccess();
            }
          })
          .catch(() => {
            this.pushSubscribeGa4(email, 'fail');
          })
          .finally(() => {
            submitBtn.dataset.apiSubmitting = 'false';
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          });
      });

      return true;
    };

    if (!bindSubmitButton()) {
      const intervalId = window.setInterval(() => {
        if (bindSubmitButton()) {
          window.clearInterval(intervalId);
        }
      }, 500);

      window.setTimeout(() => window.clearInterval(intervalId), 30000);
    }
  }

  updateEmailSubtitleOnSuccess() {
    const subtitle = this.root.querySelector('.quiz-email__label');
    if (!subtitle) return;
    subtitle.textContent = QUIZ_EMAIL_SUBTITLE_SUCCESS;
  }

  buildSubscribeContentName() {
    const formData = this.buildApiFormData('');
    const content = {};

    formData.forEach((value, key) => {
      if (key !== 'email' && value) {
        content[key] = value;
      }
    });

    return JSON.stringify(content);
  }

  getPreferredNewColor() {
    if (this.state.answers.color === 'other') {
      return this.state.answers.colorOther || 'Andere';
    }

    return this.state.answers.color || '';
  }

  buildApiFormData(email) {
    const formData = new FormData();
    formData.append('email', email);

    const preferredNewColor = this.getPreferredNewColor();
    if (preferredNewColor) formData.append('preferred_new_color', preferredNewColor);

    if (this.state.answers.price) {
      formData.append('expected_launch_price', this.state.answers.price);
    }

    if (this.state.answers.usage) {
      formData.append('primary_use_scenario', this.state.answers.usage);
    }

    if (this.state.answers.gender) {
      formData.append('gender', this.state.answers.gender);
    }

    if (this.state.answers.age) {
      formData.append('age_range', this.state.answers.age);
    }

    return formData;
  }

  getSiteCode() {
    return (this.root.dataset.site || 'uk').trim();
  }

  buildPayload(email) {
    return this.buildApiFormData(email);
  }

  async submitQuizData(email) {
    const endpoint = this.getApiEndpoint();
    const formData = this.buildApiFormData(email);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Site': this.getSiteCode(),
          'Api-Key': XS_FLASHIP_API_KEY
        },
        body: formData,
        credentials: 'omit',
        mode: 'cors'
      });

      let status = 'fail';

      try {
        const data = await response.json();
        const code = typeof data?.code === 'number' ? data.code : null;

        if (response.ok && (code === null || code === 0)) {
          status = 'success';
        } else if (data?.message && String(data.message).toLowerCase() === 'success') {
          status = 'success';
        }
      } catch {
        status = response.ok ? 'success' : 'fail';
      }

      if (status !== 'success') {
        console.warn('[flaship-quiz] submit failed');
      }

      return status;
    } catch (error) {
      console.error('[flaship-quiz] submit error', error);
      return 'fail';
    }
  }

  canProceed() {
    const step = this.state.step;

    if (step === 1) {
      if (!this.state.answers.color) return false;
      if (this.state.answers.color === 'other' && !this.state.answers.colorOther) return false;
      return true;
    }

    if (step === 2) return Boolean(this.state.answers.price);
    if (step === 3) return Boolean(this.state.answers.usage);
    if (step === 4 || step === 5) return true;
    return true;
  }

  updateProgressRing() {
    if (!this.progressFill) return;
    const progress = this.state.step / QUIZ_TOTAL_STEPS;
    const offset = QUIZ_RING_CIRCUMFERENCE * (1 - progress);
    this.progressFill.style.strokeDashoffset = String(offset);
  }

  updateStepIndex() {
    if (this.state.step > 5) return;
    const indexEl = this.root.querySelector(`.quiz-step--${this.state.step} [data-step-index]`);
    if (indexEl) {
      indexEl.textContent = `${this.state.step}/5`;
    }
  }

  playConfetti() {
    if (!this.confetti) return;
    this.confetti.classList.remove('is-active');
    void this.confetti.offsetWidth;
    this.confetti.classList.add('is-active');
  }

  updateUI() {
    this.root.dataset.step = String(this.state.step);
    this.updateProgressRing();
    this.updateStepIndex();

    if (this.prevBtn) {
      this.prevBtn.disabled = this.state.step === 1;
      this.prevBtn.hidden = false;
    }

    if (this.nextBtn) {
      this.nextBtn.hidden = this.state.step === QUIZ_TOTAL_STEPS;
      this.nextBtn.disabled = !this.canProceed();
    }

    if (this.confetti) {
      if (this.state.step === 6) {
        this.playConfetti();
      } else {
        this.confetti.classList.remove('is-active');
      }
    }
  }

  goNext() {
    if (!this.canProceed()) return;
    if (this.state.step >= QUIZ_TOTAL_STEPS) return;
    this.state.step += 1;
    this.updateUI();
  }

  goPrev() {
    if (this.state.step <= 1) return;
    this.state.step -= 1;
    this.updateUI();
  }
}

function initFlashipQuiz() {
  document.querySelectorAll('[data-quiz-root]').forEach((root) => {
    if (!root.flashipQuiz) {
      root.flashipQuiz = new FlashipQuiz(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFlashipQuiz);
} else {
  initFlashipQuiz();
}

document.addEventListener('shopify:section:load', initFlashipQuiz);
